import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        height: 22,
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
    },
    webEmbeddedChannelInfoBlock: {
        marginBottom: 12,
    },
    tabletEmbeddedChannelInfoBlock: {
        marginLeft: 44,
        marginBottom: 12,
    },
    channelLogo: {
        marginLeft: 4,
        height: 20,
    },
    channelTitle: {
        marginLeft: 4,
    },
});

export default styles;
